import { render, staticRenderFns } from "./OriginalAddress.vue?vue&type=template&id=c12814fa&scoped=true&"
import script from "./OriginalAddress.vue?vue&type=script&lang=js&"
export * from "./OriginalAddress.vue?vue&type=script&lang=js&"
import style0 from "./OriginalAddress.vue?vue&type=style&index=0&id=c12814fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12814fa",
  null
  
)

export default component.exports